<template>
  <button :type="type" class="fancy-button" :class="icon.length > 0 ? 'fancy-button--with-icon fancy-button--with-icon--black' : ''">
    <div class="fancy-button__icon" v-if="icon">
      <font-awesome-icon :icon="icon" />
    </div>
    <div class="fancy-button__content">
      <span class="fancy-button__text">
        <slot>{{ text }}</slot>
      </span>
      <span class="fancy-button__next-icon">
        <font-awesome-icon icon="long-arrow-alt-right" />
      </span>
    </div>
  </button>
</template>

<script>
export default {
  name: "fancy-button",
  props: {
    text: {
      type: String,
      required: false,
    },
    icon: {
      type: Array,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: "button"
    }
  },
};
</script>
